<template>
  <div>
    <h3 class="title-page">{{ $t("suppliers") }}</h3>
    <div class="reference_type_page">
      <div class="admin_container">
        <v-btn
          @click="editItem('add')"
          color="primary"
          style="display: block"
          dark
          class="ml-auto mb-5"
          v-if="permissions.SUPPLIER_CREATE"
        >
          <!--        <v-icon>mdi-plus</v-icon>-->
          {{ $t("create") }}
        </v-btn>
        <table-with-filter
          fixed-header
          :headers="headers"
          :items="suppliers"
          :page="configuration.page"
        >
          <template #filter.name>
            <div class="pa-1">
              <custom-input-text
                @input="getItemsByName"
                class="user_input no-margin"
                clearable
                v-model="configuration.name"
              />
            </div>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-tooltip nudge-top="35" nudge-right="10" color="#fff" left>
              <template v-slot:activator="{ on, attrs }">
                <!--If you add to 'btn_33' element 'disabled' class. it is disabled element  -->
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  class="new_style"
                  @click="editItem('update', item)"
                >
                  <vue-icon icon="newPencilIcon" />
                </v-btn>
              </template>
              <span>{{ $t("edit") }}</span>
            </v-tooltip>
            <v-tooltip nudge-top="35" nudge-right="10" color="#fff" left>
              <template v-slot:activator="{ on, attrs }">
                <!--If you add to 'btn_33' element 'disabled' class. it is disabled element  -->
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  class="new_style"
                  @click="editItem('delete', item)"
                >
                  <vue-icon icon="newTrashIcon" />
                </v-btn>
              </template>
              <span>{{ $t("delete") }}</span>
            </v-tooltip>
          </template>
        </table-with-filter>
        <vue-pagination
          @update:limit="
            (limit) => {
              configuration.limit = limit;
              configuration.page = 1;
              changePage();
            }
          "
          v-model="configuration.page"
          :length="lastPage"
          @input="changePage"
          max-page
          :limit="configuration.limit"
        />
      </div>

      <!--        modals-->
      <v-dialog v-model="dialog" max-width="500px">
        <ValidationObserver v-slot="{ handleSubmit }" ref="form">
          <v-form @submit.prevent="handleSubmit(save)">
            <v-card>
              <v-card-title>
                <span class="headline">{{ formTitle }}</span>
                <v-icon @click="dialog = false" class="info_modal_close"
                  >mdi-close
                </v-icon>
              </v-card-title>

              <v-card-text>
                <div class="edit_user_table">
                  <CustomInputText
                    rules="required"
                    v-model="editedItem.name"
                    :label="$t('name') + '*'"
                  ></CustomInputText>
                </div>
              </v-card-text>

              <v-card-actions class="footer_modal_user">
                <v-spacer></v-spacer>
                <v-btn color="#9EABBE" dark @click="close">{{
                  $t("toCancel")
                }}</v-btn>
                <v-btn color="primary" dark type="submit">{{
                  $t("save")
                }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </ValidationObserver>
      </v-dialog>
      <warning-dialog
        v-model="deleteModal"
        @apply="deleteItem"
      ></warning-dialog>
    </div>
  </div>
</template>

<script>
import WarningDialog from "../../../components/ui/prompt/warning-dialog";
import { debounce, getValueByKey } from "@/utils/pureFunctions";
import TableWithFilter from "@/components/ui/table/TableWithFilter";
import VuePagination from "@/components/ui/vue-pagination/VuePagination";

export default {
  components: { VuePagination, TableWithFilter, WarningDialog },
  data: () => ({
    dialog: false,
    deleteModal: false,
    suppliers: [],
    editedItem: {
      name: "",
    },
    configuration: {
      limit: "50",
      page: 1,
      name: null,
    },
    lastPage: 0,
    permissions: {},
  }),

  computed: {
    headers() {
      let items = [
        {
          text: "№",
          value: "index",
        },
        {
          text: this.$t("nameOfSupplier"),
          value: "name",
        },
      ];

      if (this.permissions.SUPPLIER_ACTION) {
        items.push({ text: "", value: "actions", sortable: false });
      }
      return items;
    },
    formTitle() {
      return this.editedItemId
        ? this.$t("editGroup")
        : this.$t("createSupplier");
    },
    editedItemId() {
      return this.editedItem.id;
    },
  },

  watch: {
    dialog(val) {
      if (!val) {
        const { form } = this.$refs;
        this.editedItem = {
          name: "",
        };
        if (form) form.reset();
      }
    },
  },

  methods: {
    clearModal() {
      this.editedItem = {
        name: "",
      };
    },
    editItem(type, item) {
      switch (type) {
        case "add":
          this.dialog = true;
          break;
        case "update":
          this.editedItem = { ...item };
          this.dialog = true;
          break;
        case "delete":
          this.editedItem = item;
          this.deleteModal = true;
          break;
      }
    },

    close() {
      this.dialog = false;
    },

    async deleteItem() {
      try {
        const { id } = this.editedItem;
        await this.$http.delete("supplier/delete", {
          params: {
            objectId: id,
            reason: "deleted",
          },
        });
        await this.getItems();
      } catch (e) {
        this.setResponseError({
          error: e,
        });
      }
    },
    async save() {
      try {
        this.showLoading();
        await this.$store.dispatch("createSupplier", this.editedItem);
        await this.getItems();
        this.dialog = false;
        this.clearModal();
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.clearLoading();
      }
    },
    async changePage() {
      await this.$router.replace({ query: { ...this.configuration } });
      this.showLoading();
      await this.getItems();
      this.clearLoading();
    },
    getItemsByName: debounce(async function () {
      await this.$router.replace({ query: { ...this.configuration } });
      this.showLoading();
      await this.getItems();
      this.clearLoading();
    }, 300),
    async getItems(name) {
      try {
        const params = {
          ...this.configuration,
          page: this.configuration.page - 1,
        };
        if (name) {
          params.name = name;
        }
        const { data, lastPage, permissions } = await this.$store.dispatch(
          "getSuppliers",
          params
        );
        this.lastPage = lastPage;
        this.suppliers = data;
        this.permissions = permissions;
      } catch (e) {
        this.setResponseError({ error: e });
      }
    },
  },
  async created() {
    const options = getValueByKey(this.configuration, this.$route.query);
    if (options.page && !isNaN(options.page)) options.page = +options.page;
    this.configuration = options;

    this.showLoading();
    await this.getItems();
    this.clearLoading();
  },
};
</script>

<style scoped></style>
